import { Component, Input } from "@angular/core";
import { Seller } from "../../../../objects/amazon/seller";
import { SellerModalComponent } from "./seller-modal.component";


@Component({
    selector: 'seller-item',
    templateUrl: 'seller-item.component.html',
    moduleId: module.id.toString()
})
export class SellerItemComponent {

    @Input() public seller: Seller = new Seller();

    @Input() public sellerModal: SellerModalComponent;
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/seller/seller-item.component.ts